import { render } from "./TourRegistrationView.vue?vue&type=template&id=5a46f8c0&scoped=true"
import script from "./TourRegistrationView.vue?vue&type=script&lang=js"
export * from "./TourRegistrationView.vue?vue&type=script&lang=js"

import "./TourRegistrationView.vue?vue&type=style&index=0&id=5a46f8c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a46f8c0"]])

export default __exports__